import { obtenirUrlControleur } from '../utils/urlUtils';
import District from '../modeles/District';
import { List } from 'immutable';
import fetch, { jsonHeaders } from '../utils/fetch';
import { DistrictDto } from '../modeles/DistrictDto';
import { ReponseDistrictDto } from '../modeles/ReponseDistrictDto';

const lienDistrict = obtenirUrlControleur('district');
const routeDistrict = `${lienDistrict}/api/District`;

const mapperDistrict = (district: ReponseDistrictDto) => new District({
    id: district.id ?? '',
    nom: district.nom,
    region: district.idRegion
});

export default class DistrictApi {
    static async obtenirTousLesdistricts(): Promise<List<District>> {
        return await fetch(`${routeDistrict}/districts`, { method: 'GET' })
            .then((districts) => List((Array.isArray(districts) ? (districts as ReponseDistrictDto[]) : []).map(mapperDistrict)));
    }

    static async obtenirDistrictCourant(districtId: string): Promise<District> {
        return await fetch(`${routeDistrict}/district/${districtId}`, { method: 'GET' })
            .then((district) => mapperDistrict(district as ReponseDistrictDto));
    }

    static async obtenirDistrictsRegionCourante(idRegion: string): Promise<List<District>> {
        return await fetch(`${routeDistrict}/districts`, { method: 'GET' })
            .then((districts) => {
                const tous = Array.isArray(districts) ? (districts as ReponseDistrictDto[]) : [];
                const filtres = idRegion
                    ? tous.filter(d => d.idRegion === String(idRegion))
                    : tous;
                return List(filtres.map(mapperDistrict));
            });
    }

    static async ajouterDistrict(district: DistrictDto): Promise<void> {
        await fetch(`${routeDistrict}/ajouter`, {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify(district)
        });
    }

    static async modifierDistrict(id: string, district: DistrictDto): Promise<void> {
        await fetch(`${routeDistrict}/district/${id}`, {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify(district)
        });
    }

    static async supprimerDistrict(id: string): Promise<void> {
        await fetch(`${routeDistrict}/district/${id}`, {
            method: 'DELETE',
            headers: jsonHeaders,
        });
    }
}